import React from 'react';
import styled from 'styled-components';
import {FeaturesContentCard2Up} from './FeaturesContentCard.2up';
import {FeaturesContentCardBig, FeaturesContentCardProps} from './FeaturesContentCard.big';
import {CmsComponentMapper, CmsDynamicArray} from '../../cms';
import {VerticalSpacer} from '../../spacer';
import {LineTextBlock} from '../../text/LineTextBlock';

const Styled = styled.div`
    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }
    overflow-x: clip;
`;
export interface FeaturesContentCardListProps {
    cardList?: FeaturesContentCardOptionsArray;
    title?: string;
}

export type FeaturesContentCardOptionsArray = CmsDynamicArray<FeaturesContentCardProps>;

export const FeaturesContentCardList = ({
    cardList = [],
    title = ''
}: FeaturesContentCardListProps): JSX.Element | null => {
    if (!cardList) return null;

    return (
        <Styled>
            <LineTextBlock headline={title} />
            <VerticalSpacer variant="feature" />
            <CmsComponentMapper
                dynamicPageDataArray={cardList}
                elementMapping={{
                    smallCards: <FeaturesContentCard2Up />,
                    textCards: <FeaturesContentCard2Up />,
                    bigCard: <FeaturesContentCardBig />
                }}
                itemSeparator={<VerticalSpacer variant="section" />}
            />
        </Styled>
    );
};
